import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { BmsWizard as WdwLibBmsWizard } from 'wdw-library/dist/esm/BMSWizard';

import { userStore } from '@/store/user-store';
import { computed, onBeforeMount, PropType } from 'vue';
import useAuthentication from '@/composables/user/useAuthentication';
import { domainStore } from '@/store/domain-store';


export default /*#__PURE__*/_defineComponent({
  props: {
  domainid: {
    type: Number,
    required: true,
  },
  redirectOnMessageCreated: {
    type: String,
    required: false,
    default: '',
  },
  redirectOnMessageCreatedWithMessageid: {
    type: String,
    required: false,
    default: '',
  },
  redirectOnCancel: {
    type: String,
    required: false,
    default: '',
  },
  selectedtypeid: {
    // Pre-selected typeid
    type: Number,
    required: false,
    default: 0,
  },
  initialLatitude: {
    type: Number,
    required: false,
    default: 0,
  },
  initialLongitude: {
    type: Number,
    required: false,
    default: 0,
  },
  selectedRubric: {
    // Pre-selected rubric
    type: String,
    required: false,
    default: '',
  },
  filtertypeids: {
    type: Array as PropType<number[]>,
    required: false,
    default: function () {
      return [];
    },
  },
},
  setup(__props) {

const props = __props

// eslint-disable-next-line
//@ts-ignore

const { initStorageAuthToken } = useAuthentication();

const user = computed(() => userStore.getState().user);
const authToken = computed(() => userStore.getState().authToken);
const apiBaseUrl = process.env.VUE_APP_SERVER_BASE_URL;

onBeforeMount(() => {
  domainStore.setDomainId(props.domainid);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(WdwLibBmsWizard), {
      domainid: __props.domainid,
      user: _unref(user),
      userAuthToken: _unref(authToken),
      apiBaseUrl: _unref(apiBaseUrl),
      redirectOnMessageCreated: __props.redirectOnMessageCreated,
      redirectOnMessageCreatedWithMessageid: __props.redirectOnMessageCreatedWithMessageid,
      redirectOnCancel: __props.redirectOnCancel,
      selectedtypeid: __props.selectedtypeid,
      initialLatitude: __props.initialLatitude,
      initialLongitude: __props.initialLongitude,
      selectedRubric: __props.selectedRubric,
      filtertypeids: __props.filtertypeids
    }, null, 8, ["domainid", "user", "userAuthToken", "apiBaseUrl", "redirectOnMessageCreated", "redirectOnMessageCreatedWithMessageid", "redirectOnCancel", "selectedtypeid", "initialLatitude", "initialLongitude", "selectedRubric", "filtertypeids"])
  ]))
}
}

})